import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import DeviceWrapper from '../Shared/DeviceWrapper';
import editStructure from '../../Utils/editStructure';
import SaveFab from '../Shared/SaveFab';
import StructuresSelect from '../Shared/StructuresSelect';
import renderFromStructure from '../../Utils/renderFromStructure';
import findUnknownElement from '../../Utils/findUnknownElement';
import ContentError from '../../../../Components/Error/ContentError';
import { FullSizeCenteredColumn } from '../../../../Components/FlexBox';
import encodeBase64 from '../../../../Helpers/encode';

const LandingPageTemplateContent = function LandingPageTemplateContent({
  template = null,
  handleEditTemplateList = () => {},
  handleSave = () => {},
  dynamicElement = null,
}) {
  const intl = useIntl();
  const [enableSaving, setEnableSaving] = useState(false);
  const unknown = template?.body ? findUnknownElement(template.body) : null;

  const onChangeTemplateBody = (elementToEdit) => {
    handleEditTemplateList({
      ...template,
      body: [...editStructure(elementToEdit, template?.body)],
    });
    setEnableSaving(true);
  };

  const handleSaveTemplate = () => {
    handleSave(
      {
        id: template?.id,
        name: template?.name,
        templateId: template?.templateId,
        body: encodeBase64(JSON.stringify(template?.body)),
        isNew: template?.isNew,
      },
      'LANDING'
    );
  };

  const handleSelectStructure = ({ id: templateId, body }) => {
    handleEditTemplateList({
      ...template,
      templateId,
      body,
    });
  };

  return template?.isNew && !template?.templateId ? (
    <StructuresSelect
      scope="LPG"
      handleSelectStructure={handleSelectStructure}
    />
  ) : (
    <>
      <DeviceWrapper>
        <div
          style={{
            width: '100%',
            height: '86%',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
            borderRadius: '25px 25px 0px 0px',
            overflow: 'auto',
          }}
        >
          {unknown ? (
            <FullSizeCenteredColumn>
              <ContentError
                text={intl.messages.TEMPLATE_NOT_EDITABLE}
                message={intl.formatMessage(
                  { id: 'UNKNOWN_TEMPLATE_ELEMENT' },
                  { type: unknown.type, position: unknown.path.join(' › ') }
                )}
              />
            </FullSizeCenteredColumn>
          ) : (
            renderFromStructure({
              element: template?.body,
              onChange: onChangeTemplateBody,
              name: template?.name,
              inEdit: true,
              dynamicElement,
            })
          )}
        </div>
      </DeviceWrapper>
      {!unknown && (
        <SaveFab enableSaving={enableSaving} handleSave={handleSaveTemplate} />
      )}
    </>
  );
};

LandingPageTemplateContent.propTypes = {
  template: PropTypes.object,
  handleEditTemplateList: PropTypes.func,
  handleSave: PropTypes.func,
  dynamicElement: PropTypes.object,
};

export default LandingPageTemplateContent;
